export const computed_values = {
    computed: {
        optional_data(){
            return this.$store.state.optional_data[this.this_page]
        }
    }
}